import { useMemo } from "react";
import { renderToString } from "react-dom/server";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

// This is a style that is added to the title renderer, which avoids text-transform to be
// applied to the text head title, but leaves other styles applied.
//
// This is mainly done for the HomePage title which is originally rendered in upper case
// and has a line return. The upper case is unwanted, but the line return is used to
// separate the title and subtitle with a dash.
//
const style = renderToString(
  <style>
    {`
      #_head-title-renderer * {
        text-transform: none;
      }
    `}
  </style>
);

const HeadTitle = ({ includePlatformTitle = true, ...props }) => {
  const { title } = props;

  const platformTitle = useSelector(({ platform }) => platform.title);

  // This calculates the final title text of the <title> tag by rendering the provided
  // title prop to a <div> if it's a JSX fragment and processing it's value to be visually
  // acceptable in the header (without upper case, without new lines etc..)
  const formattedTitle = useMemo(() => {
    if (!title) return "";
    if (typeof title === "string") return title;

    const titleHTML = renderToString(title);

    const renderer = document.createElement("div");
    renderer.id = "_head-title-renderer";
    renderer.innerHTML = [titleHTML, style].join("\n");
    document.body.appendChild(renderer);

    const titleText = renderer.innerText.replace(/\r|\n|\r\n/g, " - ");

    document.body.removeChild(renderer);

    return titleText;
  }, [title]);

  const headTitle = includePlatformTitle
    ? [formattedTitle, platformTitle].join(" | ")
    : formattedTitle;

  return (
    <Helmet>
      <title>{headTitle}</title>
    </Helmet>
  );
};

export default HeadTitle;
